import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, MouseEvent, MouseEventHandler } from 'react';
import { InfoButton } from './InfoIcon.style';

interface IconProps {
  onClick: (e: MouseEvent) => void;
  color?: string;
}

const InfoIcon: FunctionComponent<IconProps> = (props) => {
  const onClick: MouseEventHandler = (event) => {
    event.stopPropagation();
    props.onClick(event);
  };

  return (
    <InfoButton onClick={onClick} data-testid="info-icon">
      <FontAwesomeIcon icon={faInfoCircle} color={props.color || 'white'} style={{ fontSize: 14 }} />
    </InfoButton>
  );
};

export default InfoIcon;
